<template>

    <div class="order-details">
        <button class="prev" @click="$emit('back')">
            <img src="@/assets/icons/left.svg" height="12" width="12" :alt="$t('project_details.proposal.slider_arrow_left_alt')" />
            <span>{{ $t('project_details.orders.details.back') }}</span>
        </button>
        <div class="order-details__wrapper">
            <div class="order-details__wrapper-tabs">
                <div class="order-details__wrapper-tabs-inner">
                    <button class="tab active">{{ $t('project_details.orders.details.order_details') }}</button>
<!--                    <button class="tab">Szczegóły dostawy</button>-->
                </div>
            </div>

            <div class="orders">

                <div class="orders-title">
                    <h2>{{$t('project_details.orders.details.order') }} {{ order.id }}</h2>
                </div>

                <div v-show="!order?.id" class="loader-block">
                    <div>
                        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                    </div>
                </div>

                <div class="orders__item" v-for="product in order.products">
                    <div class="orders__item-detail">
                        <div class="orders-detail__left">
                            <template v-if="product.imagePath">
                                <img :src="product.imagePath" :alt="product.name" />
                            </template>
                            <template v-else>
                                <img src="@/assets/images/chair.png" :alt="product.name" />
                            </template>

                            <div class="product-info">
                                <p>{{ product.name }}</p>
                                <p>{{ product.id }}</p>
                                <p>{{ $t('project_details.orders.details.price') }}: {{ product.price }}</p>
                                <p>{{ $t('project_details.orders.details.amount') }}: {{ product.amount }}</p>
                            </div>

                        </div>
                        <div class="orders-detail__right">
                            <div class="bottom">
                                <p class="order-product-delivery">{{ $t('project_details.orders.details.price_with_delivery') }}: {{ product.priceWithDelivery }}</p>
<!--                                <button class="order-product-details" @click="openMoreInformation = !openMoreInformation ? true : false">-->
<!--                                    Szczegóły zamówienia-->
<!--                                    <svg xmlns="http://www.w3.org/2000/svg" width="15.412" height="24.958" viewBox="0 0 15.412 24.958">-->
<!--                                        <path id="Path_404" data-name="Path 404" d="M23.412,28.025l-9.526-9.546,9.526-9.546L20.479,6,8,18.479,20.479,30.958Z" transform="translate(-8 -6)" fill="#000000"/>-->
<!--                                    </svg>-->

<!--                                </button>-->
                            </div>
                        </div>
                    </div>

<!--                    <div v-show="openMoreInformation" class="orders__item-more-information">-->
<!--                        <div class="dimensions">-->
<!--                            <h3>Wymiary</h3>-->
<!--                            <hr />-->

<!--                           <div class="container">-->
<!--                               <div class="row">-->
<!--                                   <p>Wysokość</p>-->
<!--                                   <p>97</p>-->
<!--                               </div>-->
<!--                               <hr />-->
<!--                           </div>-->

<!--                            <div class="container">-->
<!--                                <div class="row">-->
<!--                                    <p>Wysokość</p>-->
<!--                                    <p>97</p>-->
<!--                                </div>-->
<!--                                <hr />-->
<!--                            </div>-->


<!--                        </div>-->
<!--                        <div class="construction">-->
<!--                            <h3>Konstrukcja</h3>-->
<!--                            <hr />-->
<!--                           <div class="container">-->
<!--                               <div class="row">-->
<!--                                   <p>Wykonanie stelaża</p>-->
<!--                                   <p>chrom</p>-->
<!--                               </div>-->
<!--                               <hr />-->
<!--                           </div>-->

<!--                           <div class="container">-->
<!--                               <div class="row">-->
<!--                                   <p>Wykończenie</p>-->
<!--                                   <p>skóra ekologiczna</p>-->
<!--                               </div>-->
<!--                               <hr />-->
<!--                           </div>-->
<!--                        </div>-->
<!--                    </div>-->

                    <hr />
                </div>

            </div>
        </div>
    </div>

</template>

<script>
import {ref} from "vue";
import moment from "moment";

export default {
    name: "OrderDetails",
    emits: ['back'],
    props: {
        order: Object
    },
    setup() {
        const openMoreInformation = ref(false);

        function formatDate(date) {
            return date ? moment(date).format('MM.DD.YYYY h:mm') : ''
        }

        return {
            openMoreInformation,
            formatDate,
        }
    }
}
</script>

<style scoped lang="scss">

.order-details {
    .orders-title {
        h2 {
            font: normal normal 600 2.5rem/30px Montserrat;
            margin-bottom: 60px;
        }
    }
    &>button {
       border: none;
        background-color: transparent;
        font: normal normal 500 1.5rem/2rem Montserrat;
        color: #AAAAAA;
        cursor: pointer;
        margin-bottom: 40px;
    }
    &__wrapper {
        &-tabs {
            margin-bottom: 48px;
            &-inner {
                display: flex;
                gap: 30px;

                .tab {
                    color: #767474;
                    background-color: transparent;
                    font: normal normal 500 2.5rem/3rem Montserrat;
                    border: none;
                    cursor: pointer;

                   &.active {
                       border-radius: 15px;
                       background-color: #F4F3F3;
                       color: #FF7366;
                       padding: 10px;
                   }

                }
            }
        }

        .orders {
            &__item {
                margin: 5px 0;
                &-detail {
                    display: flex;
                    justify-content: space-between;
                    margin: 0 10px;

                    .orders-detail__left {
                        display: flex;
                        align-items: center;
                        line-height: 20px;

                        @media screen and (max-width: 500px) {
                            flex-wrap: wrap;
                        }

                        img {
                            width: 150px;
                            object-fit: cover;
                        }

                        .product-info {
                            line-height: 25px;
                            padding: 0 15px;
                            p {
                                font: normal normal 500 1.8rem/22px Montserrat;
                            }
                        }
                    }

                    .orders-detail__right {
                        display: flex;
                        flex-direction: column;
                        justify-content: end;
                        text-align: right;

                        @media screen and (min-width: 700px) {
                            min-width: 225.5px;
                        }

                        .order-date {
                            font: normal normal 500 1.8rem/22px Montserrat;
                            color: #929090;
                        }

                        .order-product-delivery {
                            font: normal normal 600 1.8rem/22px Montserrat;
                        }

                        .order-product-details {
                            font: normal normal 600 1.8rem/22px Montserrat;
                            margin-left: auto;
                        }

                        .bottom {
                            p {
                                margin-bottom: 10px;
                            }

                            button {
                                color: #FF7366;
                                background-color: transparent;
                                border: none;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                gap: 10px;
                                cursor: pointer;

                                svg {
                                    width: 6px;
                                    transform: rotate(-90deg);
                                }
                            }
                        }
                    }
                }

                hr {
                    margin: 15px 0;
                    border: 0.5px solid #D4D1D1;
                }

                &-more-information {
                    display: flex;
                    gap: 40px;
                    margin-top: 20px;

                    .container {
                        .row {
                            display: flex;
                            gap: 20px;

                        }
                    }
                    h3 {
                        font: normal normal 600 1.8rem/2.2rem Montserrat;
                    }
                    .dimensions {

                    }
                }
            }
        }
    }
}

button.prev {
    display: flex;
    align-items: center;
    font-size: 1.2rem;
    color: #AAAAAA;
    background-color: transparent;
    border: none;
    gap: 5px;
    cursor: pointer;
}

.loader-block {
    text-align: center;
}
</style>